export const getCurrentTick = (state: any): number => state.global?.currentTick;
export const getTickTime = (state: any): number => state.global?.tickTime;
export const getPace = (state: any): number => state.global?.pace;
export const getPaused = (state: any): number => state.global?.paused;
export const getMenuOpen = (state: any): number => state.global?.menuOpen;
export const getDescriptionsVisible = (state: any): boolean =>
    state.global?.descriptionsVisible;
export const getFocusedMessage = (state: any): number =>
    state.global.focusedMessage;
export const getRunSeed = (state: any): number => state.global?.runSeed;
